import { QuestionsById, SurveyType } from "./types";

export const chosenReasons = (questionsById: QuestionsById<SurveyType>) => {
  return Object.entries(questionsById)
    .filter(([_, value]) => value.checked === true)
    .map(([_, value]) => value.label)
    .join(" & ");
};
